import React from "react";
import { Link } from "react-router-dom";
import "../../css/Header.css";
import HeaderImage from "../../assets/images/logo.png";
import SecondaryButton from "../components/buttons/SecondaryButton";
import PrimaryButton from "./buttons/PrimaryButton";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  return (
    <header className="main-header">
      <div className="header-logo">
        <Link to="/">
          <img src={HeaderImage} alt="logo" />
        </Link>
      </div>
      <div className="header-nav">
        <Link to="/#services" className="nav-bold">
          What we do
        </Link>
        <Link to="/#about" className="nav-bold">
          Why choose us
        </Link>
        <Link to="/#about-us" className="nav-bold">
          About us
        </Link>
        <Link to="/#values" className="nav-bold">
          Mission & Values
        </Link>
        <Link
          to="/#contact-us"
          className="nav-bold"
          style={{ textDecoration: "none" }}
        >
          <SecondaryButton text="Contact" />
        </Link>
      </div>
    </header>
  );
};

export default Header;
